import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';

interface SliderInputFieldProps extends FormlyFieldProps {
  minValue: number;
  maxValue: number;
  step: number;
  hasInput: boolean;
}

@Component({
  selector: 'app-slider-input-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectButtonModule,
    NgIf,
    SliderModule,
    InputNumberModule,
  ],
  templateUrl: './slider-input-field.component.html',
  styleUrl: './slider-input-field.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SliderInputFieldComponent
  extends FieldType<FieldTypeConfig<SliderInputFieldProps>>
  implements OnInit
{
  public ngOnInit(): void {
    this.formControl.valueChanges.subscribe(value => {
      this.formControl.setValue(value, { emitEvent: false });
    });
  }
}
